export default __webpack_public_path__ + "static/168-8f86453b6541fb6dd61f43c42720f179.jpg";